module.exports = __webpack_public_path__ + "img/tu6.8ad71218.jpg";